import { useCallback, useState, type DragEvent } from "react";
import { Upload } from "lucide-react";
import { cn } from "@/lib/cn.js";

type Props = {
  onFiles: (files: File[]) => void;
  accept?: string;
  disabled?: boolean;
};

export function DropZone({ onFiles, accept = "image/*,video/mp4", disabled }: Props): JSX.Element {
  const [over, setOver] = useState(false);

  const onDrop = useCallback((e: DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setOver(false);
    if (disabled) return;
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) onFiles(files);
  }, [onFiles, disabled]);

  return (
    <label
      className={cn(
        "flex h-32 cursor-pointer items-center justify-center gap-3 rounded border-2 border-dashed text-body transition-colors",
        over ? "border-accent bg-accent/10 text-ink" : "border-rule bg-surface-2 text-ink-soft",
        disabled && "cursor-not-allowed opacity-50",
      )}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={onDrop}
    >
      <Upload className="size-5" />
      <span>
        Trascina foto qui o <span className="font-semibold underline">scegli i file</span>
      </span>
      <input
        type="file"
        accept={accept}
        multiple
        className="hidden"
        disabled={disabled}
        onChange={(e) => {
          const files = Array.from(e.target.files ?? []);
          if (files.length > 0) onFiles(files);
          e.target.value = "";
        }}
      />
    </label>
  );
}
